import { render, staticRenderFns } from "./ManageSetting.vue?vue&type=template&id=0373d972&scoped=true&"
import script from "./ManageSetting.vue?vue&type=script&lang=js&"
export * from "./ManageSetting.vue?vue&type=script&lang=js&"
import style0 from "./ManageSetting.vue?vue&type=style&index=0&id=0373d972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373d972",
  null
  
)

export default component.exports